// Cette fonctionnalité nécessite un backend
export const pushToGit = async (commitMessage = "Update") => {
  try {
    // Ici, vous devriez faire un appel API à votre backend
    const response = await fetch('/api/deploy', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ commitMessage }),
    });

    if (!response.ok) {
      throw new Error('Deployment failed');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Deployment error:', error);
    throw error;
  }
}; 